<template>
    <v-row class="mb-4" v-show="showElements">
        <v-col cols="6" sm="6" md="3" v-if="logo">
            <v-img
                max-width="150"
                max-height="100"
                :src="logo"
            ></v-img>
        </v-col>
        <v-col cols="6" sm="6" md="9" class="text-right">
            <a v-if="loggedInProfile" class="menu-item" :href="dashboardUrl">Dashboard</a>
            <a v-if="loggedInProfile" class="menu-item last" href="#" @click="logout">Logout</a>
            <v-btn
                depressed
                tile
                x-large
                color="primary"
                class="font-weight-bold fs-1 text-transform-none"
                @click="openLoginDialog"
                v-if="!loggedInProfile"
            >
                Sign In
            </v-btn>
        </v-col>
        <LoginDialog
            :open="showLoginDialog"
            :show-close-button="true"
            @loggedIn="handleLoginEmit"
            @closed="closeLoginDialog"
        ></LoginDialog>
    </v-row>
</template>

<script>
import {computed, defineComponent, onMounted, ref} from '@vue/composition-api';
import LoginDialog from "./LoginDialog";
import axios from "axios";

export default defineComponent({
    name: 'MainMenu',
    components: { LoginDialog },
    props: {
        rootUrl: {
            type: String,
            required: true
        },
        accessToken: {
            type: String
        },
        showLoginIfLoggedOut: {
            type: Boolean
        },
        showElements: {
            type: Boolean,
            default: true
        },
        loginDialog: {
            type: Boolean,
            default: false
        },
    },
    setup(props, context) {
        const loading = ref(false);
        const logo = ref(null);
        const showLoginDialogCloseButton = ref(false);
        const loggedInProfile = ref(null);
        const token = ref(null);

        const dashboardUrl = computed(() => {
            return props.rootUrl + '/dashboard/';
        });

        const showLoginDialog = computed({
            get: () => props.loginDialog,
            set: val => {
                context.emit("showLoginDialog",val);
            }
        });

        onMounted(() => {
            init();
        });

        function init() {
            setLogo();
            if (props.accessToken !== "") {
                token.value = props.accessToken;
            }
            Promise.all([getProfile()]).then(() => {
                if (token.value == "" || _.isNull(token.value)) {
                    if(props.showLoginIfLoggedOut === true) {
                        showLoginDialog.value = true;
                        showLoginDialogCloseButton.value = false;
                    }
                    window.setHeight(1000);
                }
            });
        }

        function setLogo() {
            let logoURL = document.head.querySelector('meta[name="logo-url"]');

            if (logoURL) {
                logo.value = logoURL.content;
            }
        }

        function getProfile() {
            let sendToken = "";
            if (token.value) {
                sendToken = token.value;
            } else if (props.accessToken !== "") {
                sendToken = props.accessToken;
            }
            if (sendToken !== "") {
                loading.value = true;
                axios
                    .get("profile", {
                        headers: {
                            authorization: "Bearer " + sendToken
                        }
                    })
                    .then(function(response) {
                        loggedInProfile.value = response.data;
                        context.emit("loggedIn", {
                            loggedInProfile: response.data,
                            accessToken: sendToken
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                    })
                    .then(function() {
                        loading.value = false;
                    });
            }
            return;
        }

        function openLoginDialog() {
            showLoginDialog.value = true;
        }

        function closeLoginDialog() {
            showLoginDialog.value = false;
        }

        function handleLoginEmit(data) {
            if(data.loggedInProfile) {
                loggedInProfile.value = data.loggedInProfile;
            }
            if(data.accessToken) {
                token.value = data.accessToken;
            }

            context.emit("loggedIn", {
                loggedInProfile: data.loggedInProfile,
                accessToken: data.accessToken
            });
        }

        function removeTokenFromSessionPromise() {
            return new Promise(function(resolve, reject) {
                axios({
                    method: "post",
                    url: "remove-token-from-session",
                    baseURL: "/",
                    data: {
                        accessToken: token.value
                    }
                })
                .then(function(response) {
                    resolve(response);
                })
                .catch(function(error) {
                    reject(error);
                });
            });
        }

        function revokeTokenFromAPI() {
            let sendToken = "";
            if (token.value) {
                sendToken = token.value;
            } else if (props.accessToken !== "") {
                sendToken = props.accessToken;
            }
            if (sendToken !== "") {
                axios
                    .post(
                        "revoke-token",
                        {},
                        {
                            headers: {
                                authorization: "Bearer " + sendToken
                            }
                        }
                    )
                    .then(function(response) {})
                    .catch(function(error) {
                        console.error(error.response);
                    })
                    .then(function() {
                        window.location.reload();
                    });
            }
        }

        function logout() {
            removeTokenFromSessionPromise()
                .then((response) => {})
                .catch(function(error) {
                    console.error(error.response);
                })
                .then(function() {
                    revokeTokenFromAPI();
                });            ;
        }

        return {
            // Variables
            logo,
            showLoginDialog,
            loggedInProfile,
            dashboardUrl,
            showLoginDialogCloseButton,
            // Functions
            openLoginDialog,
            closeLoginDialog,
            handleLoginEmit,
            logout
        }
    }
});
</script>
<style lang="scss" scoped>
    .menu-item {
        text-decoration: none;
        font-weight: 600;
        margin-right: 40px;
        &.last {
            margin-right: 0px;
        }
    }
</style>
